import { CurrencyOptions } from '../../../contexts/CurrencyContext';

const RARE_ITEMS_ONLY = {
  type: 'switch',
  title: 'Rare Items Only',
};

const WHITELIST = {
  type: 'switch',
  title: 'Include Whitelist Items',
};

const RENTED = {
  type: 'switch',
  title: 'Include Rented Items',
};
const TOURNAMENT_ONLY = {
  type: 'switch',
  title: 'Tournament Rentals Only',
};

// const saleType = {
//   type: 'checkbox',
//   title: 'Sale Type',
//   labels: ['Buy Now', 'Auction'],
// };
// const saleDiscount = {
//   type: 'slider',
//   title: 'Sale Discount',
//   formatSymbol: '%',
//   marks: [
//     {
//       value: 0,
//       scaledValue: 0,
//       label: '0%',
//     },
//     {
//       value: 100,
//       scaledValue: 100,
//       label: '100%',
//     },
//   ],
// };

function price(currencyOptions: CurrencyOptions) {
  return {
    type: 'slider',
    title: 'Price',
    formatSymbol: currencyOptions.currency.symbol,
    marks: [
      {
        value: 0,
        scaledValue: 0,
        label: `${currencyOptions.currency.symbol}0`,
      },
      {
        value: 25,
        scaledValue: 10,
        label: `${currencyOptions.currency.symbol}10`,
      },
      {
        value: 50,
        scaledValue: 100,
        label: `${currencyOptions.currency.symbol}100`,
      },
      {
        value: 75,
        scaledValue: 1000,
        label: `${currencyOptions.currency.symbol}1000`,
      },
      {
        value: 100,
        scaledValue: 10000,
        label: `${currencyOptions.currency.symbol}10000`,
      },
    ],
  };
}

export function getDefaultFilterOptions(currencyOptions: CurrencyOptions) {
  return [
    WHITELIST,
    RENTED,
    TOURNAMENT_ONLY,
    RARE_ITEMS_ONLY,
    /* saleType, saleDiscount,*/ price(currencyOptions),
  ];
}
